import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/common/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import TalepTahmini from './pages/services/TalepTahmini';
import ChurnAnalizi from './pages/services/ChurnAnalizi';
import StokEnvanterYonetimi from './pages/services/StokEnvanterYonetimi';
import PredictiveMaintenance from './pages/services/PredictiveMaintenance';
import KampanyaYonetimi from './pages/services/KampanyaYonetimi';
import AnomaliTespiti from './pages/services/AnomaliTespiti';
import SatisTahinleme from './pages/services/SatisTahinleme';
import MusteriDavranisAnalizi from './pages/services/MusteriDavranisAnalizi';
import RPA from './pages/services/RPA';
import Chatbot from './pages/services/Chatbot';
import AIPoCDemo from './pages/services/AIPoCDemo';
import HrAssistant from './pages/solutions/HrAssistant';
import FinancialAssistant from './pages/solutions/FinancialAssistant';
// import LogisticsOptimization from './pages/solutions/LogisticsOptimization';
import ChatCAT from './pages/products/ChatCAT';
import TrendCAT from './pages/products/TrendCAT';
// import VehicleSegmentation from './pages/solutions/vehicle-segmentation';
import ItHelpdeskAi from './pages/solutions/ItHelpdeskAi';
import DocumentAi from './pages/solutions/DocumentAi';
import FranchiseManagement from './pages/solutions/FranchiseManagement';
import SocialSentiment from './pages/solutions/SocialSentiment';
import DemandForecasting from './pages/solutions/DemandForecasting';
import RetailCustomerExperienceAssistant from './pages/solutions/RetailCustomerExperienceAssistant';

import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/talep-tahmini" element={<TalepTahmini />} />
          <Route path="/churn-analizi" element={<ChurnAnalizi />} />
          <Route path="/stok-envanter-yonetimi" element={<StokEnvanterYonetimi />} />
          <Route path="/predictive-maintenance" element={<PredictiveMaintenance />} />
          <Route path="/kampanya-yonetimi" element={<KampanyaYonetimi />} />
          <Route path="/anomali-tespiti" element={<AnomaliTespiti />} />
          <Route path="/satis-tahinleme" element={<SatisTahinleme />} />
          <Route path="/musteri-davranis-analizi" element={<MusteriDavranisAnalizi />} />
          <Route path="/rpa" element={<RPA />} />
          <Route path="/chatbot" element={<Chatbot />} />
          <Route path="/services/ai-poc-demo" element={<AIPoCDemo />} />
          <Route path="/solutions/hr-assistant" element={<HrAssistant />} />
          <Route path="/solutions/financial-assistant" element={<FinancialAssistant />} />
          {/* <Route path="/solutions/logistics-optimization" element={<LogisticsOptimization />} /> */}
          <Route path="/products/chat-cat" element={<ChatCAT />} />
          <Route path="/products/trend-cat" element={<TrendCAT />} />
          {/* <Route path="/solutions/vehicle-segmentation" element={<VehicleSegmentation />} /> */}
          <Route path="/solutions/it-helpdesk-ai" element={<ItHelpdeskAi />} />
          <Route path="/solutions/document-ai" element={<DocumentAi />} />
          <Route path="/solutions/franchise-management" element={<FranchiseManagement />} />
          <Route path="/solutions/social-sentiment" element={<SocialSentiment />} />
          <Route path="/solutions/demand-forecasting" element={<DemandForecasting />} />
          <Route path="/solutions/retail-customer-experience-assistant" element={<RetailCustomerExperienceAssistant />} />

          {/* Eski kısa yol için alias - geriye dönük uyumluluk */}
          <Route path="/solutions/retail-customer-experience" element={<RetailCustomerExperienceAssistant />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
